<template>
  <v-container fill-height fluid grid-list-xl>
    <v-row justify="center">
      <v-col cols="12">
        <material-card
            color="green"
            flat
            full-width
            title="Robots"
        >
          <v-textarea
              v-model="text"
              label="Robots"
              rows="20"
          />
          <v-btn @click="Save">Save</v-btn>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getRobots, setRobots } from '../graphql/robots'

export default {
  name: 'Robots',
  layout: 'dashboard',
  data () {
    return {
      text: ''
    }
  },
  apollo: {
    Robots: {
      query: getRobots,
      result ({ data }) {
        if (data.getRobots !== undefined) {
          this.text = data.getRobots
        }
      }
    }
  },
  methods: {
    Save () {
      this.$apollo
          .mutate({
            mutation: setRobots,
            variables: {
              text: this.text
            }
          })
          .then((data) => {
            this.$router.go({ path: '/' })
          }).catch((error) => {
        console.log(error)
      })
    }
  }
}
</script>
